module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.firstLoading),
      expression: "firstLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "data": _vm.discounts,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "doctorName",
      "label": "Doctor"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFreeDuration",
      "label": "Free duration (Month)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "discountRate",
      "label": "Discount rate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageFeeOverDays",
      "label": "Storage Fee Over days"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showEdit(scope.row)
            }
          }
        }, [_vm._v("Edit")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Discount",
      "width": "80%",
      "visible": _vm.editVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editDiscount",
    attrs: {
      "model": _vm.editDiscount,
      "label-width": "220px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Doctor Name",
      "prop": "doctorName"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editDiscount.doctorName),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "doctorName", $$v)
      },
      expression: "editDiscount.doctorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Free Duration (Month)",
      "prop": "storageFreeDuration"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 3
    },
    model: {
      value: (_vm.editDiscount.storageFreeDuration),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "storageFreeDuration", $$v)
      },
      expression: "editDiscount.storageFreeDuration"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Discount Rate",
      "prop": "discountRate"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "step": 0.05,
      "min": 0.01,
      "max": 1.0
    },
    model: {
      value: (_vm.editDiscount.discountRate),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "discountRate", $$v)
      },
      expression: "editDiscount.discountRate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Storage Fee Over days",
      "prop": "storageFeeOverDays"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 0,
      "step": 1,
      "min": 0
    },
    model: {
      value: (_vm.editDiscount.storageFeeOverDays),
      callback: function($$v) {
        _vm.$set(_vm.editDiscount, "storageFeeOverDays", $$v)
      },
      expression: "editDiscount.storageFeeOverDays"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editVisible = false;
        _vm.getDiscounts();
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6412d32c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/warehouseAdmin/discounts.vue
// module id = 832
// module chunks = 1